import React from "react";
import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Typography } from "@mui/material";

function GenderDistributionChart(props) {
  const [outerSeries, setOuterSeries] = useState([52, 48]);
  const [innerSeries, setInnerSeries] = useState([59, 41]);

  useEffect(() => {
    if (props.gender) {
      const malePercentage = props.gender.male.count
        ? ((props.gender.male.count / props.ab.total_12_month) * 100).toFixed(1) : 0
      let femalePercentage = 0;
      if(props.gender.female.count > 0){
        femalePercentage = 100 - malePercentage;
      }
      setOuterSeries([parseFloat(malePercentage), parseFloat(femalePercentage)]);
      const total = props.gender.male.patients + props.gender.female.patients;
      const maleInnerPercentage = props.gender.male.patients / total * 100;
      let femaleInnerPercentage = 0;
      if(props.gender.female.patients > 0){
        femaleInnerPercentage = 100 - maleInnerPercentage;
      }
      setInnerSeries([parseFloat(maleInnerPercentage.toFixed(1)), parseFloat(femaleInnerPercentage.toFixed(1))]);
    }
  },[props.gender])



  const outerChartOptions = {
    chart: { type: "donut" },
    labels: ["Male", "Female"],
    colors: ["#4f9ea9", "#F58220"], // Blue for Male, Orange for Female
    plotOptions: {
      pie: {
        donut: {
          size: "60%", // Proper ring size
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${val}%`,
      style: { fontSize: "16px", fontWeight: "bold" },
    },
    legend: { show: false },
    stroke: { width: 0 },
  };

  const innerChartOptions = {
    ...outerChartOptions,
    plotOptions: {
      pie: {
        donut: { size: "40%" }, // Inner ring smaller
      },
    },
  };

  return (
    <Box sx={{ textAlign: "left", width: 350, margin: "auto" }}>
      <Typography variant="h5" sx={{ color: "#22577A", fontWeight: "bold" }}>
        Gender
      </Typography>
      <Typography variant="body1" sx={{ color: "#22577A", mb: 2 }}>
        <strong>Outer ring:</strong> antibiotics prescriptions.
        <br />
        <strong>Inner ring:</strong> patient population.
      </Typography>

      <Box sx={{ position: "relative" }}>
        {/* Outer Donut Chart */}
        <ReactApexChart
          type="donut"
          series={outerSeries} // Male, Female (Outer)
          options={outerChartOptions}
          height={300}
        />

        {/* Inner Donut Chart */}
        <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <ReactApexChart
            type="donut"
            series={innerSeries} // Male, Female (Inner)
            options={innerChartOptions}
            height={180}
          />
        </Box>
      </Box>
    </Box>
  );
}

import { connect } from "react-redux";
const mapState = state => ({
  gender: state.antibiotics.gender,
  ab: state.antibiotics.ab,
  user: state.user
});

const mapDispatch = ({
  antibiotics: { getGeneralAB }
}) => ({
  getGeneralAB: () => getGeneralAB()
});

export default connect(mapState, mapDispatch)(GenderDistributionChart);
